import { Directive, TemplateRef } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[rtSelectHeader]',
})
export class Select2HeaderDirective {
  constructor(public templateRef: TemplateRef<void>) {}
}
